"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Fortbildung = _interopRequireDefault(require("../model/Fortbildung"));
var _FortbildungCreate = _interopRequireDefault(require("../model/FortbildungCreate"));
var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* Fortbildung service.
* @module api/FortbildungApi
* @version 0.0.1
*/
class FortbildungApi {
  /**
  * Constructs a new FortbildungApi. 
  * @alias module:api/FortbildungApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Callback function to receive the result of the createFortbildungFortbildungPost operation.
   * @callback module:api/FortbildungApi~createFortbildungFortbildungPostCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Fortbildung} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Create Fortbildung
   * @param {module:model/FortbildungCreate} fortbildungCreate 
   * @param {module:api/FortbildungApi~createFortbildungFortbildungPostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Fortbildung}
   */
  createFortbildungFortbildungPost(fortbildungCreate, callback) {
    let postBody = fortbildungCreate;
    // verify the required parameter 'fortbildungCreate' is set
    if (fortbildungCreate === undefined || fortbildungCreate === null) {
      throw new Error("Missing the required parameter 'fortbildungCreate' when calling createFortbildungFortbildungPost");
    }
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _Fortbildung.default;
    return this.apiClient.callApi('/fortbildung/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the deleteFortbildungFortbildungFortbildungIdDelete operation.
   * @callback module:api/FortbildungApi~deleteFortbildungFortbildungFortbildungIdDeleteCallback
   * @param {String} error Error message, if any.
   * @param {Object} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Delete Fortbildung
   * @param {Number} fortbildungId 
   * @param {module:api/FortbildungApi~deleteFortbildungFortbildungFortbildungIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Object}
   */
  deleteFortbildungFortbildungFortbildungIdDelete(fortbildungId, callback) {
    let postBody = null;
    // verify the required parameter 'fortbildungId' is set
    if (fortbildungId === undefined || fortbildungId === null) {
      throw new Error("Missing the required parameter 'fortbildungId' when calling deleteFortbildungFortbildungFortbildungIdDelete");
    }
    let pathParams = {
      'fortbildung_id': fortbildungId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Object;
    return this.apiClient.callApi('/fortbildung/{fortbildung_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the readFortbildungFortbildungFortbildungIdGet operation.
   * @callback module:api/FortbildungApi~readFortbildungFortbildungFortbildungIdGetCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Fortbildung} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Read Fortbildung
   * @param {Number} fortbildungId 
   * @param {Object} opts Optional parameters
   * @param {String} [userId = '')] User id des angemeldeten Nutzers, um zu überprüfen welche Fortbildungen bereits gebucht wurden.
   * @param {module:api/FortbildungApi~readFortbildungFortbildungFortbildungIdGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Fortbildung}
   */
  readFortbildungFortbildungFortbildungIdGet(fortbildungId, opts, callback) {
    opts = opts || {};
    let postBody = null;
    // verify the required parameter 'fortbildungId' is set
    if (fortbildungId === undefined || fortbildungId === null) {
      throw new Error("Missing the required parameter 'fortbildungId' when calling readFortbildungFortbildungFortbildungIdGet");
    }
    let pathParams = {
      'fortbildung_id': fortbildungId
    };
    let queryParams = {
      'user_id': opts['userId']
    };
    let headerParams = {};
    let formParams = {};
    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _Fortbildung.default;
    return this.apiClient.callApi('/fortbildung/{fortbildung_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the readFortbildungenFortbildungGet operation.
   * @callback module:api/FortbildungApi~readFortbildungenFortbildungGetCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/Fortbildung>} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Read Fortbildungen
   * @param {Object} opts Optional parameters
   * @param {Number} [skip = 0)] Einträge die beim Abrufen aus der Datenbank übersprungen werden sollen.
   * @param {Number} [limit = 100)] Anzahl der Einträge die abgerufen werden sollen.
   * @param {String} [typ = 'kfv')] Typ der Fortbildung. Entweder 'kfv' oder 'kjf'
   * @param {String} [userId = '')] User id des angemeldeten Nutzers, um zu überprüfen welche Fortbildungen bereits gebucht wurden.
   * @param {Boolean} [showAll = false)] Standardmäßig werden nur nicht ausgelaufene Fortbildungen angezeigt. Ist diese Feld wahr, werden alle angezeigt.
   * @param {Boolean} [showMine = false)] Standardmäßig werden alle Fortbildungen angezeigt. Ist diese Feld wahr, werden nur die selbst gebuchten Fortbildungen angezeigt.
   * @param {module:api/FortbildungApi~readFortbildungenFortbildungGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Array.<module:model/Fortbildung>}
   */
  readFortbildungenFortbildungGet(opts, callback) {
    opts = opts || {};
    let postBody = null;
    let pathParams = {};
    let queryParams = {
      'skip': opts['skip'],
      'limit': opts['limit'],
      'typ': opts['typ'],
      'user_id': opts['userId'],
      'showAll': opts['showAll'],
      'showMine': opts['showMine']
    };
    let headerParams = {};
    let formParams = {};
    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = [_Fortbildung.default];
    return this.apiClient.callApi('/fortbildung/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the updateFortbildungFortbildungFortbildungIdPatch operation.
   * @callback module:api/FortbildungApi~updateFortbildungFortbildungFortbildungIdPatchCallback
   * @param {String} error Error message, if any.
   * @param {module:model/FortbildungCreate} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Update Fortbildung
   * @param {Number} fortbildungId 
   * @param {module:model/FortbildungCreate} fortbildungCreate 
   * @param {module:api/FortbildungApi~updateFortbildungFortbildungFortbildungIdPatchCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/FortbildungCreate}
   */
  updateFortbildungFortbildungFortbildungIdPatch(fortbildungId, fortbildungCreate, callback) {
    let postBody = fortbildungCreate;
    // verify the required parameter 'fortbildungId' is set
    if (fortbildungId === undefined || fortbildungId === null) {
      throw new Error("Missing the required parameter 'fortbildungId' when calling updateFortbildungFortbildungFortbildungIdPatch");
    }
    // verify the required parameter 'fortbildungCreate' is set
    if (fortbildungCreate === undefined || fortbildungCreate === null) {
      throw new Error("Missing the required parameter 'fortbildungCreate' when calling updateFortbildungFortbildungFortbildungIdPatch");
    }
    let pathParams = {
      'fortbildung_id': fortbildungId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _FortbildungCreate.default;
    return this.apiClient.callApi('/fortbildung/{fortbildung_id}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }
}
exports.default = FortbildungApi;